import React, { useState, useCallback } from "react";
import styles from "./mobile-menu.module.scss";
import MenuItems from "./MenuItems";
import ProgramSearcher from "./ProgramSearcher";
import ProgramSearchResults from "./ProgramSearchResults";
import Programs from "./Programs";
import ProgramsListing from "./ProgramsListing";
interface ProgramsDetails {
  categoryTitle: string;
  programsList: Array<unknown>;
}
interface MobileMenuOptProps {
  isSponsoredCertificates: boolean;
  isMenuOpen: boolean;
  menuPage: number;
  setMenuPage: (page: number) => void;
}

const MobileMenuOpt: React.FC<MobileMenuOptProps> = ({
  isSponsoredCertificates,
  isMenuOpen,
  menuPage,
  setMenuPage,
}) => {
  const [searchValue, setSearchValue] = useState<string>("");
  const [programsDetails, setProgramsDetails] = useState<ProgramsDetails>({
    categoryTitle: "",
    programsList: [],
  });

  // Memoized handler for menu page changes
  const onClickHandler = useCallback((pageValue: number) => {
    setMenuPage(pageValue);

    setTimeout(() => {
      window.webengage.track("Programs Clicked");
    }, 2500);
  }, []);

  return (
    <div
      className={`${styles.mobileMenuWrapper} ${isMenuOpen ? styles.open : ""}`}
      aria-hidden={!isMenuOpen}
      tabIndex={-1}
    >
      <div className={styles.parentMainContainer}>
        {/* Program Searcher */}
        <ProgramSearcher
          searchValue={searchValue}
          setSearchValue={setSearchValue}
        />

        <div className={styles.mobileMenuContainer}>
          {/* Conditional Rendering for Search Results and Menu Pages */}
          <ProgramSearchResults searchValue={searchValue} />

          <MenuItems
            onMenuItemClick={onClickHandler}
            showMenuItem={!searchValue && menuPage === 0}
            isSponsoredCertificates={isSponsoredCertificates}
          />

          <Programs
            setMenuPage={setMenuPage}
            setProgramsDetails={setProgramsDetails}
            showPrograms={!searchValue && menuPage === 1}
          />

          <ProgramsListing
            setMenuPage={setMenuPage}
            programsDetails={programsDetails}
            showProgramsListing={!searchValue && menuPage === 2}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(MobileMenuOpt);
